export default {
  'menu.welcome': '欢迎',
  'menu.users': '用户管理',
  'menu.users.list': '用户列表',
  'menu.users.groups': '用户组管理',
  'menu.users.admins': '管理员',
  'menu.videos': '视频管理',
  'menu.videos.list': '视频列表',
  'menu.videos.zones': '分区管理',
  'menu.videos.players': '播放器管理',
  'menu.content': '内容运营',
  'menu.content.ranks': '排行榜',
  'menu.content.recommends': '首页推荐',
  'menu.content.weekday': '周更排期',
  'menu.content.topics': '专题',
  'menu.content.sensitive': '言论配置',
  'menu.danmaku': '弹幕管理',
  'menu.danmaku.list': '弹幕列表',
  'menu.danmaku.config': '弹幕配置',
  'menu.comments': '评论管理',
  'menu.comments.list': '评论列表',
  'menu.comments.config': '评论配置',
  'menu.operations': '运营管理',
  'menu.operations.notices': '公告管理',
  'menu.operations.adverts': '广告管理',
  'menu.pay': '支付管理',
  'menu.pay.products': '商品配置',
  'menu.pay.orders': '订单管理',
  'menu.pay.memberships': '会员开通',
  'menu.system': '系统管理',
  'menu.system.settings': '系统设置',
  'menu.system.search': '搜索设置',
  'menu.system.configs': '应用配置',
  'menu.system.versions': '版本管理',
  'menu.system.avatars': '头像管理',
  'menu.login': '登录',
};
